module.exports = "https://cdn-assessment.mathletics.com/app/122/assets/images/d066cb014e078abf696e36bf50fcd6ce.svg";